import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getAuthenticatedUser } from '../../services/user-service'

export const getUserAction = createAsyncThunk('auth/fetchUser', async () => {
  return await getAuthenticatedUser()
})

const initialState = {
  isAuthLoading: true,
  xAuthToken: null,
  partnerId: null,
  userName: null,
  userId: null,
  emailId: null,
  impVendorIds: null,
  domVendorIds: null,
  dvsVendorIds: null,
  vendorsInfo: null,
  challengeAuthentication: false,
  userType: 'E', //External has lesser privileges compared to internal. So, initializing with external
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setChallengeAuthenticationAction: (state, action) => {
      const { payload } = action

      state.challengeAuthentication = payload
    },
    setUserType: (state, action) => {
      const { payload } = action

      state.userType = payload
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getUserAction.pending, state => {
        state.isAuthLoading = true
      })
      .addCase(getUserAction.fulfilled, (state, action: { payload: any }) => {
        const { payload } = action

        state.isAuthLoading = false
        state.partnerId = payload.data.partnerId
        state.userName = payload.data.userName
        state.impVendorIds = payload.data.impVendors
        state.domVendorIds = payload.data.domVendors
        state.dvsVendorIds = payload.data.dvsVendors
        state.vendorsInfo = payload.data.vendorsInfo
        state.userId = payload.data.userId
        state.emailId = payload.data.emailId
        state.userType = payload.data.userType
      })
  },
})

export const getChallengeAuthentication = state =>
  state.auth.challengeAuthentication
export const getUserName = state => state.auth.userName

export const { setChallengeAuthenticationAction, setUserType } =
  authSlice.actions

export default authSlice.reducer
